import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="auth-wrap"><div className="spin" style={{ borderColor: "var(--cyan)", borderTopColor: "transparent" }} /></div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
